<template>
  <div class="header">
    <div
      class="nav-bar"
      :style="{ backgroundColor: backgroundColor,
                paddingTop: `calc(env(safe-area-inset-bottom) + (${statusbarHeight}%))` }">
      <span v-if="isSubPage"  class="back" @click="goBack" :style="{backgroundImage:'url('+this.getBackIcon()+')'}"></span>
      <h1 :style="{'color':titleColor}">{{ title }}</h1>
      <span class="right-btn-wrapper">
        <slot name="rightBtn"></slot>
      </span>
    </div>
  </div>
</template>

<script>

import backIconBlack from '@/assets/images/icons/icon-back.png'
import backIconWhite from '@/assets/images/icons/icon-back-white2.png'
export default {
  name: 'Header',

  props: {
    title: {
      type: String,
      required: true
    },
    isSubPage: {
      type: Boolean,
      default: false
    },
    isNativeHandle: { // 需要通过原生来处理
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    titleColor: {
      type: String,
      default: '#03081A'
    },
    backImg: {
      type: String,
      default: '~@/assets/images/icons/icon-back.png'
    },
    isBlackIcon: {
      type: Boolean,
      default: true
    },
    callbackFun: {
      type: String,
      default: null
    },
    isReturn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      statusbarHeight: 0,
      blackIcon: backIconBlack,
      whiteIcon: backIconWhite
    }
  },
  beforeMount () {
    if (this.$route.query.statusBarHeight) {
      this.statusbarHeight = this.$route.query.statusBarHeight || 0
      sessionStorage.setItem('statusbarHeight', this.$route.query.statusBarHeight)
    } else {
      this.statusbarHeight = sessionStorage.getItem('statusbarHeight') || 0
    }
  },
  methods: {
    goBack () {
      console.log('go back click')
      if (this.isNativeHandle) {
        this.$dfzhJsBridge.goBack()
      } else {
        if (this.isReturn) {
          this.$router.go(-1)
        }
      }

      if (this.callbackFun != null && this.callbackFun !== '') {
        this.$emit(this.callbackFun)
      }
    },
    getBackIcon () {
      console.log('isblackIcon=' + this.isBlackIcon)
      return this.isBlackIcon ? this.blackIcon : this.whiteIcon
    }

  }
}
</script>
<!--background url("~@/assets/images/icons/icon-back.png") no-repeat 16px center-->
<style lang="stylus">
.nav-bar
  height 44px
  width 100%
  line-height: 44px
  padding-top constant(safe-area-inset-bottom)
  padding-top env(safe-area-inset-bottom)
  //padding-top 20px
  background-color #fff
  position relative
  h1
    font-size 16px
    color #03081A
    font-weight bold
  .back
    position absolute
    left 0
    bottom 0
    width 44px
    height 44px
    background url("~@/assets/images/icons/icon-back.png") no-repeat 16px center
    background-size 12px 24px
  .right-btn-wrapper
    position absolute
    right 0
    bottom 0
    height 44px
    .btn
      display inline-block
      width 44px
      height 44px
  .integralRule
    font-size 15px
    color #ffffff
    margin-right 15px
  .finish
    font-size 15px
    color black
    margin-right 15px
</style>
